import { Briefcase, Truck, ArrowUpRight } from "lucide-react";

const divisions = [
  {
    key: "consulting",
    tag: "Division I",
    icon: Briefcase,
    title: "Consulting & Advisory",
    desc:
      "Federal capture, agile transformation, procurement, staffing, and executive advisory for agencies and enterprises nationwide.",
    href: "#services",
    cta: "Explore Services",
    bullets: [
      "Government Consulting",
      "Project Management",
      "Business Strategy",
      "Staffing & HR",
    ],
    testid: "division-consulting",
  },
  {
    key: "logistics",
    tag: "Division II",
    icon: Truck,
    title: "Logistics & Transportation",
    desc:
      "DOT-authorized motor carrier operating dedicated lanes, Amazon Relay routes, USPS mail contracts, and full-truckload freight across the continental U.S.",
    href: "#logistics",
    cta: "Enter Logistics",
    bullets: [
      "US DOT # 4311432",
      "MC # 1680527",
      "GL $1M / $2M · Cargo $1M",
      "Continental U.S. Coverage",
    ],
    testid: "division-logistics",
  },
];

export const Divisions = () => {
  return (
    <section
      id="divisions"
      data-testid="divisions-section"
      className="relative bg-[#050914] py-24 md:py-32 border-b border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-14 md:mb-20">
          <p className="text-[11px] font-bold uppercase tracking-[0.32em] text-[#d4af37] mb-5 reveal">
            <span className="gold-rule" /> One Firm · Two Divisions
          </p>
          <h2 className="font-serif-editorial text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] text-white reveal">
            Advisory that <span className="italic text-[#d4af37]">wins contracts.</span>
            <br />
            Freight that <span className="italic text-[#d4af37]">keeps them moving.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {divisions.map((d) => {
            const Icon = d.icon;
            return (
              <a
                key={d.key}
                href={d.href}
                data-testid={d.testid}
                className="group relative bg-[#0a1324] hover:bg-[#0f1a2f] transition-colors duration-500 p-8 md:p-12 flex flex-col justify-between min-h-[440px] reveal"
              >
                <div>
                  <div className="flex items-center justify-between mb-8">
                    <span className="text-[10px] uppercase tracking-[0.3em] text-slate-500">
                      {d.tag}
                    </span>
                    <Icon size={30} strokeWidth={1.2} className="text-[#d4af37]" />
                  </div>
                  <h3 className="font-serif-editorial text-3xl md:text-4xl lg:text-5xl text-white leading-[1.05]">
                    {d.title}
                  </h3>
                  <p className="mt-5 text-slate-400 leading-relaxed max-w-md">
                    {d.desc}
                  </p>
                  <ul className="mt-8 grid grid-cols-1 gap-2">
                    {d.bullets.map((b) => (
                      <li
                        key={b}
                        className="text-[11px] uppercase tracking-[0.22em] text-slate-300 flex items-center gap-3"
                      >
                        <span className="w-1.5 h-1.5 bg-[#d4af37] rounded-full" />
                        {b}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="mt-10 flex items-center justify-between border-t border-white/10 pt-6">
                  <span className="text-[12px] font-bold uppercase tracking-[0.28em] text-white group-hover:text-[#d4af37] transition-colors">
                    {d.cta}
                  </span>
                  <ArrowUpRight
                    size={22}
                    className="text-slate-500 group-hover:text-[#d4af37] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                  />
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Divisions;
